/**
 * @param {string} value - The input string to be transformed.
 * @returns {string} The transformed string in snake_case.
 */
export function convertToSnakeCase(value) {
  return value
    .replaceAll(/([a-z])([A-Z])/g, '$1_$2')
    .replaceAll(/([0-9])([A-Z])/g, '$1_$2')
    .replaceAll(/([0-9])([a-z])/g, '$1_$2')
    .toLowerCase()
    .replace(/\W+/g, '_')
    .replace(/_{2,}/g, '_')
    .replace(/^_|_$/g, '')
}

/**
 * @param {Record<string, string>} object - The input object with keys to be converted.
 * @returns {Record<string, string>} A new object with the keys converted to snake_case.
 */
export function convertKeysToSnakeCase(object) {
  const convertedEntries = Object.entries(object).map(function ([key, value]) {
    return [convertToSnakeCase(key), value]
  })

  return Object.fromEntries(convertedEntries)
}
